import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';
import { getVisitedLocationsReport } from '../services/visitedLocationsReport.service';
import { formatLocationReportItem } from '../utils/helpers';
import { VisitedLocationsReportSlice } from '../types';
import { ReportsSlice, ReportType } from '../../../types';

export const visitedLocationsInitialState: VisitedLocationsReportSlice = {
  isFailed: false,
  isLoading: false,
  transports: {},
};

export const resetState = createAction('visitedLocations/resetState');

export const visitedLocationsReducers = (
  builder: ActionReducerMapBuilder<ReportsSlice<VisitedLocationsReportSlice>>,
) => {
  builder.addCase(getVisitedLocationsReport.pending, (state) => {
    state[ReportType.VISITED_LOCATIONS].isLoading = true;
  });

  builder.addCase(getVisitedLocationsReport.fulfilled, (state, action) => {
    state[ReportType.VISITED_LOCATIONS].isLoading = false;

    Object.entries(action.payload.transports).forEach(([key, value]) => {
      const visited = value.visited.map(formatLocationReportItem).flat();

      const notVisited = value.notVisited
        .map(formatLocationReportItem)
        .flat()
        .sort((a, b) => a.name.localeCompare(b.name));

      state[ReportType.VISITED_LOCATIONS].transports[Number(key)] = {
        visited,
        notVisited,
        total: {
          visited: visited.length,
          notVisited: notVisited.length,
          all: visited.length + notVisited.length,
        },
        uniqueTotal: {
          visited: value.visited.length,
          notVisited: value.notVisited.length,
          all: value.visited.length + value.notVisited.length,
        },
      };
    });
  });

  builder.addCase(getVisitedLocationsReport.rejected, (state) => {
    state[ReportType.VISITED_LOCATIONS].isLoading = false;
    state[ReportType.VISITED_LOCATIONS].isFailed = true;
  });

  builder.addCase(resetState, (state) => {
    state[ReportType.VISITED_LOCATIONS] = visitedLocationsInitialState;
  });
};
